import React from "react"

export default function SupportLink() {
  return (
    <li className="top-icon">
      <a
        href="https://help.myrecoverylink.com/"
        target="_blank"
        rel="noreferrer"
      >
        <span className="material-icons top-icon-span">help</span>
        <label className="top-menu-label">Support</label>
      </a>
    </li>
  )
}
